import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { CoreService, NotificationService } from '../services'

@Injectable({
  providedIn: 'root',
})
export class FileUtilService {
  constructor(
    private readonly translateService: TranslateService,
    private readonly core: CoreService,
    private readonly notificationService: NotificationService,
  ) {}
  async processUploadedFileToBase64(file: any): Promise<string | any> {
    return new Promise((resolve, reject) => {
      if (file) {
        const reader = new FileReader()
        reader.readAsBinaryString(new Blob([file]))
        reader.onload = evt => {
          resolve({
            text: file.name,
            originalFilename: file.name,
            mimeType: file.type,
            base64Data: `data:application/octet-stream;base64,${btoa(String(evt?.target?.result))}`,
          })
        }
        reader.onerror = () => {
          reject(this.translateService.instant('file-util.file-processing-error'))
        }
      } else {
        reject(this.translateService.instant('no-file'))
      }
    })
  }

  async processDownloadedData(blob: Blob, file): Promise<string | any> {
    return new Promise((resolve, reject) => {
      if (file) {
        const reader = new FileReader()
        reader.onloadend = evt => {
          const filename = file.name || file.originalFilename || 'image'
          resolve({
            text: filename,
            originalFilename: filename,
            mimeType: file.mimeType || file.type || blob.type,
            base64Data: `data:application/octet-stream;base64,${btoa(String(evt?.target?.result))}`,
          })
        }
        reader.onerror = () => {
          reject(this.translateService.instant('file-util.file-processing-error'))
        }
        reader.readAsBinaryString(blob)
      } else {
        reject(this.translateService.instant('no-file'))
      }
    })
  }

  async downloadFile(url: string, fileName: string): Promise<void> {
    if (!url) {
      console.warn('downloadFile called without a valid URL')
      return
    }
    try {
      const blob = await this.core.services.http.downloadBlob(url)
      const objectUrl = window.URL.createObjectURL(blob)
      const anchor = document.createElement('a')
      document.body.appendChild(anchor)
      anchor.href = objectUrl
      anchor.download = fileName
      anchor.click()
      document.body.removeChild(anchor)
      setTimeout(() => {
        window.URL.revokeObjectURL(objectUrl)
      }, 60000)
    } catch (e) {
      console.warn('downloadFile failed with downloadBlob, attempting fallback direct download:', e)
      try {
        const anchor = document.createElement('a')
        anchor.href = url
        anchor.download = fileName
        anchor.target = '_blank'
        document.body.appendChild(anchor)
        anchor.click()
        document.body.removeChild(anchor)
      } catch (fallbackError) {
        console.error('Fallback download also failed:', fallbackError)
      }
      const msg = this.translateService.instant('alert.file.download.error')
      this.notificationService.error(
        msg && msg !== 'alert.file.download.error' ? msg : 'Došlo k chybě při stahování souboru.',
      )
    }
  }
}
